export default "__VITE_ASSET__DfetbXMG__"